import { Component, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { knowledgeFinancialAssetsOptions } from '@app/forms/subscription/services/ref';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'scpi-knowledge',
    templateUrl: './scpi-knowledge.component.html',
    styleUrls: ['./scpi-knowledge.component.scss'],
    standalone: false
})
export class ScpiKnowledgeComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  knowledgeFinancialAssetsOptions = knowledgeFinancialAssetsOptions;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.displayErrors();

    if (this.form.valid) {
      const pledge = this.subscriptionFacade.getPledge();
      const { accountInformations } = this.extract() || {};
      pledge.accountInformations = {
        ...pledge?.accountInformations,
        ...accountInformations,
      };

      this.subscriptionFacade
        .putPledge({ ...pledge })
        .pipe(untilDestroyed(this))
        .subscribe(data => {
          this.subscriptionFacade.nextStep();
        });
    }
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
